import { DOCUMENT, PAY_FREQUENCY } from '@config/constants';
import { DOCUMENT_KEYS } from '@views/ProofDocuments/components';
import { areDocumentsApproved } from './useAreDocumentsReady';

export const isClassApproved = (type, documents, paymentFrequency) => ({
  [DOCUMENT_KEYS.OFFICIAL_ID]: () => (
    isClassApproved(DOCUMENT_KEYS.PASSPORT, documents)
    || isClassApproved(DOCUMENT_KEYS.ID_CARD, documents)),
  [DOCUMENT_KEYS.PASSPORT]: () => {
    const passport = documents.filter(
      (document) => document.documentType === DOCUMENT_KEYS.PASSPORT,
    );
    return areDocumentsApproved({ documents: passport });
  },
  [DOCUMENT_KEYS.ID_CARD]: () => {
    const idCard = documents.filter(
      (document) => document.documentType === DOCUMENT_KEYS.ID_CARD,
    );

    // we need both sides of the ID card
    return areDocumentsApproved({ documents: idCard }) && idCard.length >= 2;
  },
  [DOCUMENT_KEYS.PROOF_OF_ADDRESS]: () => {
    const address = documents.filter(
      (document) => document.documentType === DOCUMENT_KEYS.PROOF_OF_ADDRESS,
    );
    return areDocumentsApproved({ documents: address });
  },
  [DOCUMENT_KEYS.PROOF_OF_INCOME]: () => (
    isClassApproved(DOCUMENT_KEYS.BANK_STATEMENT, documents)
    || isClassApproved(DOCUMENT_KEYS.PAYSLIP, documents, paymentFrequency)
  ),
  [DOCUMENT_KEYS.BANK_STATEMENT]: () => {
    const incomes = documents.filter(
      (document) => document.documentType === DOCUMENT_KEYS.BANK_STATEMENT,
    );

    const first = incomes.filter(
      (income) => income.documentGrouping === DOCUMENT.GROUPS.LAST_PERIOD,
    );
    const second = incomes.filter(
      (income) => income.documentGrouping === DOCUMENT.GROUPS.ONE_PERIOD_AGO,
    );

    const bankStatements = [...first, ...second];

    // we need 2 months of bank statements
    return areDocumentsApproved({ documents: bankStatements }) && bankStatements.length >= 2;
  },
  [DOCUMENT_KEYS.PAYSLIP]: () => {
    const incomes = documents.filter(
      (document) => document.documentType === DOCUMENT_KEYS.PAYSLIP,
    );

    const first = incomes.filter(
      (income) => income.documentGrouping === DOCUMENT.GROUPS.LAST_PERIOD,
    );
    const second = incomes.filter(
      (income) => income.documentGrouping === DOCUMENT.GROUPS.ONE_PERIOD_AGO,
    );
    const third = incomes.filter(
      (income) => income.documentGrouping === DOCUMENT.GROUPS.TWO_PERIODS_AGO,
    );
    const fourth = incomes.filter(
      (income) => income.documentGrouping === DOCUMENT.GROUPS.THREE_PERIODS_AGO,
    );

    if (paymentFrequency === PAY_FREQUENCY.MONTHLY) {
      const payslips = [...first, ...second];
      // if the user has a monthly payment frequency, we only need 2 payslips
      return areDocumentsApproved({ documents: payslips }) && payslips.length >= 2;
    }

    const payslips = [...first, ...second, ...third, ...fourth];
    // if the user has a bi-weekly or weekly payment frequency, we need 4 payslips
    return areDocumentsApproved({ documents: payslips }) && payslips.length >= 4;
  },
  [DOCUMENT_KEYS.PROOF_OF_ACTIVITY]: () => (
    isClassApproved(DOCUMENT_KEYS.TAX_SITUATION, documents)
    || isClassApproved(DOCUMENT_KEYS.OPERATING_LICENSE, documents)
  ),
  [DOCUMENT_KEYS.TAX_SITUATION]: () => {
    const taxes = documents.filter(
      (document) => document.documentType === DOCUMENT_KEYS.TAX_SITUATION,
    );
    return areDocumentsApproved({ documents: taxes });
  },
  [DOCUMENT_KEYS.OPERATING_LICENSE]: () => {
    const license = documents.filter(
      (document) => document.documentType === DOCUMENT_KEYS.OPERATING_LICENSE,
    );
    return areDocumentsApproved({ documents: license });
  },
}[type]());
